import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	all: {
		id: 'software-releases-version-related-work.category-filter.all',
		defaultMessage: 'All',
		description:
			'Label for a button that shows all related work items, regardless of the category they are in.',
	},
	ariaFilterLabel: {
		id: 'software-releases-version-related-work.category-filter.aria-filter-label',
		defaultMessage: 'Filter related work by category',
		description:
			'Aria label for the category filter button that allows users to filter related work items by category.',
	},
});
